module.exports = __webpack_public_path__ + "img/pulsing-circle.a8b3050.gif";